<div
  class="upload-file-container"
  *ngIf="{
           associateModuleId: id$ | async,
           associationModule: module$ | async,
           associationType: type$ | async,
           candidateId: candidateId$ | async
         } as params"
>
  <form
    [formGroup]="form"
    class="form-group"
  >
    <div class="step-content">
      <h3 class="upload-header">Upload
        {{ params.associationType === associationTypes.OTHERS ? 'file' : 'resume' }}
      </h3>
      <div
        *ngIf="params.associationType === associationTypes.RESUME"
        class="upload-info mb-4"
      >
        Once uploaded, this new file will become the default resume for the
        candidate.
      </div>
      <common-mojo-file-upload
        (uploaded)="file?.setValue($event)"
        [text]="uploadText$ | async"
        buttonText="(PDF, Word or Rich Text)"
      >
      </common-mojo-file-upload>
    </div>

    <div class="buttons-container text-center">
      <button
        color="accent"
        class="mr-3"
        mat-button
        (click)="close()"
      >
        Cancel
      </button>
      <button
        mat-flat-button
        color="primary"
        class="md"
        [disabled]="!file.value"
        (click)="upload(file?.value, params)"
      >
        SAVE
      </button>
    </div>
  </form>
</div>
